var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.clContainer()},[_c('button',{class:_vm.clSub('input', ("form__input " + _vm.inputClass)),attrs:{"id":_vm.id,"name":_vm.name,"placeholder":_vm.placeholder,"value":_vm.data}},[_vm._t("append",null,{"state":_vm.state})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }